import config from 'config'
import axios from 'axios'

class ApiService {
  private _accessToken: string | null;
  private _apiBaseUrl: string;
  private _syncApiBaseUrl: string;
  private _consentApiBaseUrl: string;
  private _apiUrl: string;
  private _syncApiUrl: string;
  private _consentApiUrl: string;
  private _authorizationHeader: {};

  constructor () {
    this._accessToken = null
    this._apiBaseUrl = config.api.apiBaseUrl
    this._syncApiBaseUrl = config.api.syncApiBaseUrl
    this._consentApiBaseUrl = config.api.consentApiBaseUrl
    this._apiUrl = ''
    this._syncApiUrl = ''
    this._consentApiUrl = ''
    this._authorizationHeader = {}
  }

  get authorizationHeader () {
    return {
      ...this._authorizationHeader,
      Authorization: 'Bearer: ' + this._accessToken
    }
  }

  get apiUrl (): string {
    return this._apiUrl
  }

  set apiUrl (url: string) {
    this._apiUrl = this._apiBaseUrl + url
  }

  get syncApiUrl (): string {
    return this._syncApiUrl
  }

  set syncApiUrl (url: string) {
    this._syncApiUrl = this._syncApiBaseUrl + url
  }

  get consentApiUrl (): string {
    return this._consentApiUrl
  }

  set consentApiUrl (url: string) {
    this._consentApiUrl = this._consentApiBaseUrl + url
  }

  get accessToken (): string | null {
    return this._accessToken
  }

  set accessToken (accessToken: string | null) {
    this._accessToken = accessToken
    if (accessToken) {
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
      delete axios.defaults.headers.common.Authorization
    }
  }

  /**
   * Call a get request with axios
   * @param url
   */
  post (url: string, parameters?: {}) {
    this.apiUrl = url
    return axios.post(this.apiUrl, parameters)
  }

  /**
   * Call a get request with axios
   * @param url
   */
  get (url: string, parameters?: {}) {
    this.apiUrl = url
    return axios.get(this.apiUrl, { params: parameters })
  }

  /**
   * Call a get request with axios
   * @param url
   */
  consentGet (url: string, parameters?: {}) {
    this.consentApiUrl = url
    return axios.get(this.consentApiUrl, { params: parameters })
  }
}

export default ApiService
